import { render, staticRenderFns } from "./MonitoringChart.vue?vue&type=template&id=b3cb37d0&scoped=true"
import script from "./MonitoringChart.vue?vue&type=script&lang=js"
export * from "./MonitoringChart.vue?vue&type=script&lang=js"
import style0 from "./MonitoringChart.vue?vue&type=style&index=0&id=b3cb37d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb37d0",
  null
  
)

export default component.exports